import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import { Link } from "../../lib/Link";

export const beginner_case3 = type => {
  document.title =
    "トランクルームをお探しなら『ハローストレージ』【公式】｜ひみつ基地";
  return (
    <div className="container">
      {breadcrumbs(type, [
        { href: "/beginner/", text: "初めての方へ" },
        { text: "ひみつ基地" },
      ])}
      
      <div className="beginner_contents_detail">
        <div className="main">
          <div id="width">
            <div className="sub">
              <img
                src="resource/img/static/beginner/beginner_case3.jpg"
                alt=""
                className="example"
              />
              <div className="frame1 pc">
                <h1>
                  ひみつ基地
                  <span>アクティビティの中継基地に大活躍</span>
                </h1>
                <p>
                  キャンプ、登山、ロードバイク、など、ブームの兆しを見せるアウトドア趣味の数々。
                  <br />
                  最新モデルや新アイテムをゲットしたら心踊りますよね。
                  <br />
                  ただそのアイテム、全て家の中に置いておかないといけませんか？
                  <br />
                  トランクルームに収納すれば、スペース補充としてだけではなく、お出かけ前のチェックポイントとしても活用できます。
                </p>
              </div>
              <div className="frame1 sp">
                <h1>ひみつ基地</h1>
                <p>アクティビティの中継基地に大活躍</p>
              </div>
              <div className="sp">
                <p>
                  キャンプ、登山、ロードバイク、など、ブームの兆しを見せるアウトドア趣味の数々。最新モデルや新アイテムをゲットしたら心踊りますよね。
                  ただそのアイテム、全て家の中に置いておかないといけませんか？
                  トランクルームに収納すれば、スペース補充としてだけではなく、
                  お出かけ前のチェックポイントとしても活用できます。
                </p>
              </div>
            </div>
            <div className="cases1 cases">
              <img
                src="resource/img/static/beginner/beginner_case3_1.jpg"
                alt=""
                className="sample"
              />
              <div className="text-box">
                <h1>盗まれたくない大切なロードバイクをトランクルームに収納</h1>
                <p>
                  トランクルームがあなた専用ガレージに早変わり。
                  <br className="pc" />
                  大切なロードバイク、パーツやメンテナンス用品を
                  <br className="pc" />
                  おしゃれにディスプレイ。
                  <br className="pc" />
                  インスタ映えする空間で仲間に自慢しませんか。
                </p>
              </div>
              <br clear="left pc" />
            </div>
            <div className="cases2 cases">
              <img
                src="resource/img/static/beginner/beginner_case3_2.jpg"
                alt=""
                className="sample"
              />
              <div className="text-box">
                <h1>スノボ サーフィン シーズン毎の
                <br className="pc" />
                スポーツの収納にピッタリ</h1>
                <p>
                  シーズンごとのスポーツ道具の収納に、
                  <br className="pc" />
                  トランクルームはピッタリ。
                  <br className="pc" />
                  日常使いをしない道具たちを季節と一緒に
                  <br className="pc" />
                  入れ替えてあげましょう。
                </p>
              </div>
              <br clear="right pc" />
            </div>
            <div className="cases3 cases">
              <img
                src="resource/img/static/beginner/beginner_case3_3.jpg"
                alt=""
                className="sample"
              />
              <div className="text-box">
                <h1>キャンプ道具などを収納、
                <br className="pc" />
                お出かけ前の
                <br className="pc" />
                チェックポイントに</h1>
                <p>
                  アウトドアスポットまでの中継地点に。
                  <br className="pc" />
                  トランクルームをキャンプ道具などの
                  <br className="pc" />
                  収納場所としてだけではなく、
                  <br className="pc" />
                  お出かけ前のチェックポイントとしても活用できます！
                </p>
              </div>
              <br clear="left pc" />
            </div>
            <Link to="/list/" className="finding">
              いますぐ探す
            </Link>
            <div className="background">
              <h2>その他の利用シーン</h2>
            </div>
            <div className="others pc">
              <Link to="/beginner/case1/">
                <img
                  src="resource/img/static/beginner/beginner_case1.jpg"
                  alt=""
                  className="example"
                />
              </Link>
              <Link to="/beginner/case2/">
                <img
                  src="resource/img/static/beginner/beginner_case2.jpg"
                  alt=""
                  className="example"
                />
              </Link>
              <div className="frame2">
                <Link to="/beginner/case1/" className="frame">
                  <h1>見せる収納</h1>
                  <p>思い出をインテリアのように楽しむ</p>
                </Link>
              </div>
              <div className="frame3">
                <Link to="/beginner/case2/" className="frame">
                  <h1>コレクション部屋</h1>
                  <p>大好きなものたちに囲まれて</p>
                </Link>
              </div>
            </div>
            <div className="others sp">
              <Link to="/beginner/case1/">
                <img
                  src="resource/img/static/beginner/beginner_case1.jpg"
                  alt=""
                  className="example"
                />
                <div className="frame2">
                  <h1>見せる収納</h1>
                  <p>思い出をインテリアのように楽しむ</p>
                </div>
              </Link>
            </div>
            <div className="others sp">
              <Link to="/beginner/case2/">
                <img
                  src="resource/img/static/beginner/beginner_case2.jpg"
                  alt=""
                  className="example"
                />
                <div className="frame3">
                  <h1>コレクション部屋</h1>
                  <p>大好きなものたちに囲まれて</p>
                </div>
              </Link>
            </div>
            <div className="information">
              <div className="pc">
                <Link to="/lineup/" className="textArea">
                  <img src="resource/img/static/beginner/lineup.png" />
                  <span>
                    商品ラインナップは
                    <br />
                    こちら
                  </span>
                </Link>
                <Link to="/flow/" className="textArea">
                  <img src="resource/img/static/beginner/flow.png" />
                  <span>
                    お申し込みから
                    <br />
                    ご契約の流れまで
                  </span>
                </Link>
                <Link to="/voice2/" className="textArea">
                  <img src="resource/img/static/beginner/voice.png" />
                  <span>
                    実際の
                    <br />
                    お客様の声
                  </span>
                </Link>
              </div>
              <div className="sp">
                <Link to="/lineup/" className="text1">
                  <img src="resource/img/static/beginner/lineup_sp.png" />
                  <span>
                    商品ラインナップは
                    <br />
                    こちら
                  </span>
                </Link>
                <Link to="/flow/" className="text2">
                  <img src="resource/img/static/beginner/flow_sp.png" />
                  <span>
                    お申し込みから
                    <br />
                    ご契約の流れまで
                  </span>
                </Link>
                <Link to="/voice2/" className="text3">
                  <img src="resource/img/static/beginner/voice_sp.png" />
                  <span>
                    実際の
                    <br />
                    お客様の声
                  </span>
                </Link>
              </div>
              <br className="left" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/beginner_case3.jsx